import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bec75d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "div-page-content-desc" }
const _hoisted_3 = { id: "kaiku-agree-title-h1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { id: "kaiku-agree-descrption-sub" }
const _hoisted_6 = { class: "div-page-content-area" }
const _hoisted_7 = { id: "kaiku-agree-subtitle-what-is-h3" }
const _hoisted_8 = {
  key: 0,
  class: "body"
}
const _hoisted_9 = {
  key: 1,
  class: "body"
}
const _hoisted_10 = {
  key: 2,
  class: "body"
}
const _hoisted_11 = { class: "body" }
const _hoisted_12 = {
  key: 0,
  href: "https://kaiku.docrates.com/sv/terms/data_processing",
  target: "_blank"
}
const _hoisted_13 = {
  key: 1,
  href: "https://kaiku.docrates.com/fi/terms/data_processing",
  target: "_blank"
}
const _hoisted_14 = { id: "kaiku-agree-subtitle-agreement-h3" }
const _hoisted_15 = { class: "divCheckbox" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 3,
  class: "two-button-container"
}
const _hoisted_18 = {
  key: 4,
  class: "two-button-container"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_spinner = _resolveComponent("custom-spinner")!
  const _component_custom_info_note_confirmation = _resolveComponent("custom-info-note-confirmation")!
  const _component_custom_alert_note = _resolveComponent("custom-alert-note")!

  return (_ctx.error === null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-title")), 1),
          _hoisted_4,
          _createElementVNode("sub", _hoisted_5, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-description")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-subtitle-what-is")), 1),
          (_ctx.orderTestServiceFound())
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-text-what-is-order-test-1")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-text-what-is-1")), 1)),
          (!_ctx.orderTestServiceFound())
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-text-what-is-2")), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.store.getters.translate("kaiku-agree-text-what-is-3")) + " ", 1),
            (_ctx.getSelectedLanguage == 'sv')
              ? (_openBlock(), _createElementBlock("a", _hoisted_12, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-text-what-is-link")), 1))
              : (_openBlock(), _createElementBlock("a", _hoisted_13, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-text-what-is-link")), 1))
          ]),
          _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-subtitle-agree-terms")), 1),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "checkbox",
              id: "checkboxKaikuAgree",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checked) = $event)),
              disabled: _ctx.inProgress
            }, null, 8, _hoisted_16), [
              [_vModelCheckbox, _ctx.checked]
            ]),
            _createElementVNode("label", {
              class: _normalizeClass(["labelCheckbox", {
            labelCheckboxChecked: _ctx.checked
          }]),
              for: "checkboxKaikuAgree"
            }, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-checkbox-agree")), 3)
          ]),
          (_ctx.orderTestServiceFound())
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("button", {
                  id: "kaiku-agree-return-button",
                  class: "buttonReturn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.doAbort && _ctx.doAbort(...args)))
                }, _toDisplayString(_ctx.store.getters.translate("generic-abort")), 1),
                _createElementVNode("button", {
                  id: "kaiku-agree-continue-button",
                  class: "buttonContinue",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.agree && _ctx.agree(...args)))
                }, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-button-agree")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("button", {
                  id: "kaiku-agree-return-button",
                  class: "buttonReturn",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.doReturn && _ctx.doReturn(...args)))
                }, _toDisplayString(_ctx.store.getters.translate("generic-return")), 1),
                _createElementVNode("button", {
                  id: "kaiku-agree-continue-button",
                  class: "buttonContinue",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.agreeAndSend && _ctx.agreeAndSend(...args)))
                }, _toDisplayString(_ctx.store.getters.translate("kaiku-agree-button-send")), 1)
              ]))
        ]),
        _createVNode(_component_custom_spinner, { loading: _ctx.inProgress }, null, 8, ["loading"])
      ]))
    : (_ctx.error === 'Cancel')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_custom_info_note_confirmation, {
            msg: "CANCEL-KAIKU-AGREE",
            title: _ctx.store.getters.translate('info-note-cancel-order-test-title'),
            header: _ctx.store.getters.translate('info-note-cancel-order-test-header'),
            text1: _ctx.store.getters.translate('info-note-cancel-appointment-text'),
            text2: "",
            button1: _ctx.store.getters.translate('generic-not'),
            button2: _ctx.store.getters.translate('cancel-and-return'),
            onCloseNote: _cache[5] || (_cache[5] = ($event: any) => (_ctx.error = null)),
            onCancelKaikuAgree: _ctx.cancelOrderTest
          }, null, 8, ["title", "header", "text1", "button1", "button2", "onCancelKaikuAgree"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_custom_alert_note, {
            title: _ctx.store.getters.translate('alert-kaiku-agree-failed-title'),
            text: _ctx.store.getters.translate('alert-kaiku-agree-failed-text'),
            subtext: _ctx.store.getters.translate('alert-kaiku-agree-failed-subtext'),
            button: _ctx.store.getters.translate('generic-return'),
            onRedirect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.error = null))
          }, null, 8, ["title", "text", "subtext", "button"])
        ]))
}